import { ISelectCarmaOption } from "../Select/types";

export const ALL_MODELS_OPTION: ISelectCarmaOption = { id: 0, label: "All Models", value: 0 };